document.addEventListener('DOMContentLoaded', () => {
  const selectors = document.querySelectorAll('.model-size-selector');
  if (!selectors.length) return;

  selectors.forEach((selector) => {
    const options = selector.querySelectorAll('.model-size-selector__option');
    if (!options.length) return;

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        if (option.classList.contains('model-size-selector__option--active')) return;

        options.forEach((opt) => {
          opt.classList.remove('model-size-selector__option--active');
          opt.setAttribute('aria-selected', 'false');
        });

        option.classList.add('model-size-selector__option--active');
        option.setAttribute('aria-selected', 'true');

        const value = (option.dataset.modelSizeValue || option.textContent || '').trim();
        handleModelSizeChange(value, selector);
      });
    });
  });

  applyModelSizeFromHash();
});

window.addEventListener('hashchange', () => {
  applyModelSizeFromHash();
});

function applyModelSizeFromHash() {
  const hash = window.location.hash.toLowerCase();
  if (!hash.startsWith('#model-size-')) return;

  const value = hash.replace('#model-size-', '').trim();
  if (!value) return;

  const selectors = document.querySelectorAll('.model-size-selector');
  if (!selectors.length) return;

  selectors.forEach((selector) => {
    const options = selector.querySelectorAll('.model-size-selector__option');
    if (!options.length) return;

    const match = Array.from(options).find((option) => {
      const optionValue = (option.dataset.modelSizeValue || option.textContent || '')
        .toLowerCase()
        .trim();
      return optionValue === value;
    });

    if (!match) return;

    // Update active state
    options.forEach((opt) => {
      opt.classList.remove('model-size-selector__option--active');
      opt.setAttribute('aria-selected', 'false');
    });

    match.classList.add('model-size-selector__option--active');
    match.setAttribute('aria-selected', 'true');

    handleModelSizeChange(value, selector);
  });
}


function handleModelSizeChange(value, selector) {
  if (!value) return;

  const normalizedValue = value.toLowerCase();
  const context = selector.dataset.modelSizeContext || 'collection';

  if (context === 'product') {
    handleProductGallery(normalizedValue, selector);
  } else if (context === 'collection') {
    handleCollectionCards(normalizedValue);
  }
}

function handleProductGallery(value, selector) {
  const sectionId = selector.dataset.modelSizeSectionId;
  const productSection = sectionId
    ? document.querySelector(`#MainProduct-${sectionId}`)
    : document.querySelector('.product-wrapper');

  if (!productSection) return;

  const mediaContainer = productSection.querySelector('.product__media');
  if (!mediaContainer) return;

  if (value === 'all') {
    scrollProductMedia(mediaContainer, 0);
    return;
  }

  const targetKey = `model-size: ${value}`;
  const targetImage = Array.from(mediaContainer.querySelectorAll('img[alt]')).find((img) => {
    return typeof img.alt === 'string' && img.alt.toLowerCase().includes(targetKey);
  });

  if (!targetImage) return;

  const slideTargeted = focusSplideSlide(targetImage);
  if (!slideTargeted) {
    targetImage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function scrollProductMedia(container, index) {
  if (typeof window.main !== 'undefined' && window.main && typeof window.main.go === 'function') {
    window.main.go(index);
    return;
  }

  const image = container.querySelector('img');
  if (image) {
    image.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function focusSplideSlide(targetImage) {
  if (typeof window.main === 'undefined' || !window.main || typeof window.main.go !== 'function') {
    return false;
  }

  const root = window.main.root || document.querySelector('#main-carousel');
  if (!root) return false;

  const slides = root.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
  if (!slides.length) return false;

  const targetSlide = targetImage.closest('.splide__slide');
  if (!targetSlide) return false;

  const index = Array.from(slides).indexOf(targetSlide);
  if (index < 0) return false;

  window.main.go(index);
  return true;
}

function handleCollectionCards(value) {
  if (!document.body.classList.contains('template-collection')) return;

  const cards = document.querySelectorAll('.template-collection .product-card');
  if (!cards.length) return;

  cards.forEach((card) => {
    const mediaPrimary = card.querySelector('.product-card__media .media--primary');
    if (!mediaPrimary) return;

    const mediaRollover = card.querySelector('.product-card__media .media--rollover');
    const templates = card.querySelectorAll('template.model-size-template');

    // Only process cards that have model-size templates
    if (!templates.length) return;

    const picture = mediaPrimary.querySelector('picture');
    const img = picture?.querySelector('img');
    const sources = picture?.querySelectorAll('source');

    if (!picture || !img || !sources || sources.length < 2) return;

    let rolloverPicture = null;
    let rolloverImg = null;
    let rolloverSources = null;

    if (mediaRollover) {
      rolloverPicture = mediaRollover.querySelector('picture');
      rolloverImg = rolloverPicture?.querySelector('img');
      rolloverSources = rolloverPicture?.querySelectorAll('source');
    }

    if (!mediaPrimary.dataset.originalImgSrc) {
      mediaPrimary.dataset.originalImgSrc = img.src;
      mediaPrimary.dataset.originalImgAlt = img.alt || '';
      sources.forEach((source, index) => {
        if (source.srcset) {
          mediaPrimary.dataset[`originalSrcset${index}`] = source.srcset;
        }
      });

      if (rolloverImg && rolloverSources && rolloverSources.length >= 2) {
        mediaPrimary.dataset.originalRolloverImgSrc = rolloverImg.src;
        mediaPrimary.dataset.originalRolloverImgAlt = rolloverImg.alt || '';
        rolloverSources.forEach((source, index) => {
          if (source.srcset) {
            mediaPrimary.dataset[`originalRolloverSrcset${index}`] = source.srcset;
          }
        });
      }
    }

    if (value === 'all') {
      if (img.src === mediaPrimary.dataset.originalImgSrc) return;

      img.src = mediaPrimary.dataset.originalImgSrc;
      img.alt = mediaPrimary.dataset.originalImgAlt || '';
      sources.forEach((source, index) => {
        const originalSrcset = mediaPrimary.dataset[`originalSrcset${index}`];
        if (originalSrcset) {
          source.srcset = originalSrcset;
        }
      });

      if (rolloverImg && rolloverSources && rolloverSources.length >= 2) {
        const originalRolloverSrc = mediaPrimary.dataset.originalRolloverImgSrc;
        const originalRolloverAlt = mediaPrimary.dataset.originalRolloverImgAlt;
        if (originalRolloverSrc) {
          rolloverImg.src = originalRolloverSrc;
          rolloverImg.alt = originalRolloverAlt || '';
          rolloverSources.forEach((source, index) => {
            const originalSrcset = mediaPrimary.dataset[`originalRolloverSrcset${index}`];
            if (originalSrcset) {
              source.srcset = originalSrcset;
            }
          });
        }
      }
      return;
    }

    const targetKey = `model-size: ${value}`;
    const match = Array.from(templates).find((template) => {
      const templateAlt = template.dataset.modelSizeAlt || '';
      return templateAlt.toLowerCase().includes(targetKey);
    });

    if (!match) return;

    const templatePrimary = match.content.querySelector('.model-size-primary picture');
    const templatePrimaryImg = templatePrimary?.querySelector('img');
    const templatePrimarySources = templatePrimary?.querySelectorAll('source');

    const templateRollover = match.content.querySelector('.model-size-rollover picture');
    const templateRolloverImg = templateRollover?.querySelector('img');
    const templateRolloverSources = templateRollover?.querySelectorAll('source');

    if (templatePrimaryImg && templatePrimarySources && templatePrimarySources.length >= 2) {
      if (img.src === templatePrimaryImg.src) return;

      img.src = templatePrimaryImg.src;
      img.alt = templatePrimaryImg.alt || '';

      sources.forEach((source, index) => {
        if (templatePrimarySources[index] && templatePrimarySources[index].srcset) {
          source.srcset = templatePrimarySources[index].srcset;
        }
      });
    }

    if (templateRolloverImg && templateRolloverSources && templateRolloverSources.length >= 2 && rolloverImg && rolloverSources && rolloverSources.length >= 2) {
      rolloverImg.src = templateRolloverImg.src;
      rolloverImg.alt = templateRolloverImg.alt || '';

      rolloverSources.forEach((source, index) => {
        if (templateRolloverSources[index] && templateRolloverSources[index].srcset) {
          source.srcset = templateRolloverSources[index].srcset;
        }
      });
    }
  });
}

